// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"718a6798","441":"ee9b2595","690":"5e22c5a4","854":"62403861"}[chunkId] + ".chunk.css";
};